// removed by extract-text-webpack-plugin
module.exports = {"Notes":"Notes__Notes__38Xew"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Order/Notes/Notes.css
// module id = 204
// module chunks = 1